import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Movie, PageService } from '../../services/Page/page.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TopSliderComponent } from "../top-slider/top-slider.component";
import { SafeHtmlPipe } from "../../pipes/safe-html.pipe";
import { PosterListComponent } from "../poster-list/poster-list.component";
import { TopImageRotatorComponent } from "../top-image-rotator/top-image-rotator.component";
import { MatIconModule } from "@angular/material/icon";
import { BookingService } from '../../services/Booking/booking.service';
import { AuthService } from '../../services/Auth/auth.service';
import { TopVideoComponent } from "../top-video/top-video.component";
import { SearchService } from '../../services/Search/search.service';
import { connectConfigure, connectHits, connectSearchBox } from 'instantsearch.js/es/connectors';
import { BaseHit } from 'instantsearch.js';

@Component({
    selector: 'app-title-page',
    imports: [
        CommonModule,
        RouterModule,
        TopSliderComponent,
        SafeHtmlPipe,
        PosterListComponent,
        TopImageRotatorComponent,
        MatIconModule,
        TopVideoComponent,
    ],
    templateUrl: './title-page.component.html',
    styleUrl: './title-page.component.scss'
})
export class TitlePageComponent {
    public currentRoute: string = ''
    public movie: Movie | undefined

    public starring: string = ''

    public youMayLikeList: Movie[] = []

    public isInWishlist: boolean = false
    public filterCache: string = ''
    public hits: BaseHit[] = [];
    public movies: Movie[] = []
    public cachedFranchiseResults: Movie[] = []
    public genre: string = ''
    public refine!: (query: string) => void;

    public additionalFormats: string[] = []

    constructor(
        public pageService: PageService,
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public bookingService: BookingService,
        public authService: AuthService,
        public searchService: SearchService

    ) {
        this.searchService.addWidgets([
            connectSearchBox(({ refine, query }) => {
                // this.refine = refine;
                this.refine = refine;
                // this.query = query;
            })({
                // ...widgetParameters
            }),
            connectConfigure(({ refine }) => {
                // this.configureRefine = refine;
                // Initial filter setup
                const initialFilters = this.buildFilters();
                if (this.filterCache != initialFilters.filters) {
                    this.filterCache = initialFilters.filters
                    refine(initialFilters);
                }
            })({
                searchParameters: {}
            }),
            connectHits(({ hits }) => {
                this.hits = hits;

                this.movies = []

                // ids = ids.filter(item => item != undefined)
                let movies = this.hits.map(hit => {
                    let movie = new Movie(hit)
                    movie.Dx = hit['objectID']
                    return movie
                })
                movies = movies.filter(item => item != undefined)
                if (this.cachedFranchiseResults.length > 0) {

                    // filter out movies already in cached franchise results
                    let filteredMovies = movies.filter(item => {
                        var foundItem = this.cachedFranchiseResults.find(movie => {
                            return movie.Dx == item?.Dx
                        })
                        if (foundItem == undefined) return true
                        return false
                    })

                    movies = [...this.cachedFranchiseResults, ...filteredMovies]
                }
                else {
                    if (this.movie?.Franchise != '' && this.movie?.Franchise != 'JOHN WICK') {
                        if(this.hits && this.hits.length>0 && this.hits[0]['_highlightResult'].Franchise != undefined && this.hits[0]['_highlightResult'].Franchise == this.movie?.Franchise) {
                            movies = movies.filter(item => {
                                // console.log(item.Franchise)
                                return item.Franchise == this.movie?.Franchise
                            })

                        }

                    }
                }
                this.movies = movies.filter(item => item.Dx != this.movie?.Dx)
                if (this.movies.length > 10) {
                    this.movies = this.movies.splice(0, 10)
                }
                if (this.movie?.Franchise != '' && this.movie?.Franchise != 'JOHN WICK' && this.cachedFranchiseResults.length == 0) {
                    this.movies.sort((a, b) => a.Release - b.Release)
                    if (this.movies.length > 0 && this.movies.length < 10) {
                        this.cachedFranchiseResults = this.movies
                        if (this.movie) {

                            this.genre = this.movie.GenreList[0]
                            if (this.genre != '') {
                                this.refine('')
                            }
                        }
                    }
                }

            })({}),
        ]);
    }

    // Build filter string based on form values
    private buildFilters(): { filters: string } {

        let filters = '';

        // Add genre filters with AND logic
        if (this.genre != '') {
            filters = `GenreList:"${this.genre}"`
        }

        return { filters };
    }

    ngOnDestroy() {
        // Remove InstantSearch widgets when the component is destroyed
        this.searchService.removeWidgets();
    }

    ngOnInit() {
        // this.currentRoute = this.activatedRoute.snapshot.url.map(segment => segment.path).join('/');

        this.activatedRoute.paramMap.subscribe(params => {

            let id = params.get('id')
            if (id != null) {

                const Dx = parseInt(id); // 'id' is the parameter name from your route
                if (Dx) {

                    this.pageService.getMoviesByIds([Dx]).then(movies => {
                        if (movies.length) {
                            this.cachedFranchiseResults = []
                            this.genre = ""
                            this.movie = movies[0]

                            this.starring = this.movie?.CastList[0]

                            this.pageService.getMoviesByIds(this.pageService.homePage.featured).then(movies => this.youMayLikeList = movies)

                            this.authService.wishList$.subscribe((wishList) => {
                                if (this.movie) {
                                    this.isInWishlist = wishList.includes(this.movie.Dx)
                                }
                            })

                            this.movie.FormatList.forEach((format) => {
                                if(format != 'Rights Only -Self Supplied' && !format.includes('DCP') && format != '35mm Print') {
                                    this.additionalFormats.push(format);
                                }
                            }) 

                            if (this.movie.Franchise != '' && this.movie.Franchise != "JOHN WICK") {
                                this.refine(this.movie.Franchise)
                            }
                            else {

                                this.genre = this.movie.GenreList[0]
                                if (this.genre != '') {
                                    this.refine('')
                                }
                            }
                        }
                    })
                }
            }
        });

    }

    getBgList(): string[] {
        if (this.movie && this.movie.pageBgList) {
            return this.movie.pageBgList
        }
        return []
    }

    onBook() {
        if (this.movie) {
            this.bookingService.open(this.movie)
        }
    }

    onWishlist() {
        if (this.movie) {

            if (!this.isInWishlist) {
                this.authService.addToWishList(this.movie.Dx, this.movie);
            }
            else {
                this.authService.removeFromWishlist(this.movie.Dx)
            }
        }

    }

}
